import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingCategoryLinkPrefetchingThresholdMs } from "@faire/retailer-visitor-shared/settings/useSettingCategoryLinkPrefetchingThresholdMs";
import { useSettingNextJSRscCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRscCategoryPage";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import React from "react";
export var useCategoryNavigationPrefetch = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var _useNextRouterContext = useNextRouterContext(), nextPrefetch = _useNextRouterContext.prefetch;
    var isRSCCategoryPageEnabled = useSettingNextJSRscCategoryPage();
    var shouldEnableNextJSPrefetch = isLoggedInRetailer && isRSCCategoryPageEnabled;
    var timeoutRef = React.useRef(undefined);
    var CATEGORY_LINK_PREFETCH_THRESHOLD_MS = useSettingCategoryLinkPrefetchingThresholdMs();
    var onMouseEnter = React.useCallback(function(url) {
        if (shouldEnableNextJSPrefetch) {
            timeoutRef.current = setTimeoutIfPossible(function() {
                if (url) {
                    nextPrefetch(url, {
                        kind: PrefetchKind.FULL
                    });
                }
            }, CATEGORY_LINK_PREFETCH_THRESHOLD_MS);
        }
    }, [
        nextPrefetch,
        shouldEnableNextJSPrefetch,
        CATEGORY_LINK_PREFETCH_THRESHOLD_MS
    ]);
    var onTouchStart = React.useCallback(function(url) {
        if (shouldEnableNextJSPrefetch && url) {
            nextPrefetch(url, {
                kind: PrefetchKind.FULL
            });
        }
    }, [
        nextPrefetch,
        shouldEnableNextJSPrefetch
    ]);
    var onBlur = React.useCallback(function() {
        if (shouldEnableNextJSPrefetch) {
            clearTimeout(timeoutRef.current);
        }
    }, [
        shouldEnableNextJSPrefetch
    ]);
    return {
        prefetchOnMouseEnter: onMouseEnter,
        prefetchOnTouchStart: onTouchStart,
        clearPrefetchTimeoutOnBlur: onBlur
    };
};
// check if current url start with /category
export var isCategoryUrl = function(url) {
    return /^\/category\//.test(url);
};
